import { render, staticRenderFns } from "./gantt-template.vue?vue&type=template&id=13356661"
import script from "./gantt-template.vue?vue&type=script&lang=js"
export * from "./gantt-template.vue?vue&type=script&lang=js"
import style0 from "./gantt-template.vue?vue&type=style&index=0&id=13356661&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports